import React from 'react';
import Styled from './styles';
import { Button, TextField, Select, Checkbox } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { FormControl, MenuItem } from 'material-ui';
import api from '../../../lib/api';
import LinkGenerated from '../LinkGenerated';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: 0
  },
  textField: {
    marginRight: theme.spacing.unit,
    width: 276,
    border: '1px solid #C4C4C4',
    borderRadius: '5px',
    padding: '10px'
  },
  input: {
    fontSize: 16,
    fontWeight: 'normal',
    '&[type=number]': {
      '-moz-appearance': 'textfield'
    },
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  button: {
    backgroundColor: '#42FFBB',
    color: 'black',
    fontSize: 14,
    fontWeight: 900,
    borderRadius: 8,
    padding: '15px',
    '&:hover': {
      backgroundColor: '#42FFBB'
    }
  },
  estimateButton: {
    backgroundColor: 'rgba(66, 255, 187, 0.5)',
    color: 'black',
    fontSize: 14,
    fontWeight: 900,
    borderRadius: 8,
    padding: '15px',
    '&:hover': {
      backgroundColor: 'rgba(66, 255, 187, 0.5)'
    }
  }
});
class GenerateUpgradePaymentLink extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      showLinkGenerated: false,
      companyId: '',
      companyName: '',
      userPhone: '',
      userEmail: '',
      validTill: '',
      validTime: '',
      expiryTime: '',
      address: '',
      city: '',
      state: '',
      country: '',
      pan: '',
      gstn: '',
      contactName: '',
      customerEmailId: '',
      salesType: '',
      prorationNeeded: false,
      salesRepEmails: [],
      salesPersonPrimaryEmail: 'Select Primary Email',
      salesPersonSecondaryEmail: 'Select Secondary Email',
      errorMessage: '',
      planType: 'GROWTH',
      originalAmount: '',
      duration: '',
      offerMessage: '',
      discountType: 'Discount %',
      discountPercent: '',
      discountAmount: '',
      refundDays: '',
      salesLink: '',
      finalDiscountPercentage: '',
      finalAmount: '',
      planExpiryTime: '',
      isIOSNativeApp: false,
      isAndroidNativeApp: false,
      isResellerChannels: false,
      isResellerApp: false,
      isPrivacyModule: false,
      isWhitelabel: false,
      isAmazonVoucherOf2k: false,
      isAdditionalMonths: false,
      isThirdPartyIntegrations: false,
      errorCompanyID: false,
      errorDuration: false,
      errorAddress: false,
      errorCity: false,
      errorState: false,
      errorCountry: false,
      errorPan: false,
      errorGstn: false,
      errorContactName: false,
      errorSalesPersonalPrimaryEmail: false,
      errorSalesPersonalSecondaryEmail: false,
      errorCustomerEmailId: false,
      errorValidTill: false,
      errorValidTime: false,
      errorPlanAmount: false,
      errorDiscountPercent: false,
      errorDiscountAmount: false,
      errorRefundDays: false,
      errorGetEstimate: false,
      errorGeneratedLink: false,
      errorActivationDate: false,
      errorActivationTime: false,
      disableTextField: true,
      disableDiscountField: true,
      disablePlanTypeActivationTime: false,
      loading: false
    };
  }

  componentDidMount() {
    api
      .getSalesPersonEmail()
      .then(({ salesRepEmails }) => {
        this.setState({ salesRepEmails });
      })
      .catch(reason => console.log(reason));
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.companyId && this.state.companyId !== prevState.companyId) {
      api
        .getSalesType(this.state.companyId)
        .then(({ salesType, prorationNeeded }) => {
          this.setState({ salesType, prorationNeeded });
        })
        .catch(reason => console.log(reason));
    }
  }

  companyIdChange = e => {
    if (!e.target.value) {
      this.setState({
        companyName: '',
        userPhone: '',
        userEmail: '',
        planExpiryTime: ''
      });
    }
    this.setState({ companyId: e.target.value, errorCompanyID: false });
  };
  getCompanyDetails = async e => {
    e.preventDefault();
    e.stopPropagation();

    if (e.target.value) {
      try {
        this.setState({ loading: true, disableTextField: true });
        const {
          target: { value }
        } = e;
        let companyId = value;
        let {
          companyName,
          userPhone,
          userEmail,
          expiryTime: planExpiryTime
        } = await api.getCompanyIdDetails(companyId);

        this.setState({
          companyName: companyName,
          userPhone: userPhone,
          userEmail: userEmail,
          loading: false,
          disableTextField: false,
          planExpiryTime
        });
      } catch (error) {
        console.log(error.response.statusText);

        this.setState({
          companyName: '',
          userPhone: '',
          userEmail: '',
          loading: false,
          disableTextField: true,
          errorCompanyID: true,
          planExpiryTime: ''
        });
      }
    }
  };
  onIOSNativeAppChange = e => {
    this.setState({
      isIOSNativeApp: !this.state.isIOSNativeApp
    });
  };
  onAndroidNativeAppChange = e => {
    this.setState({
      isAndroidNativeApp: !this.state.isAndroidNativeApp
    });
  };
  onResellerChannelsChange = e => {
    this.setState({
      isResellerChannels: !this.state.isResellerChannels
    });
  };
  onResellerAppChange = e => {
    this.setState({
      isResellerApp: !this.state.isResellerApp
    });
  };
  onPrivacyModuleChange = e => {
    this.setState({
      isPrivacyModule: !this.state.isPrivacyModule
    });
  };
  onWhitelabelChange = e => {
    this.setState({
      isWhitelabel: !this.state.isWhitelabel
    });
  };
  onAmazonVoucherOf2kChange = e => {
    this.setState({
      isAmazonVoucherOf2k: !this.state.isAmazonVoucherOf2k
    });
  };
  onAdditionalMonthsChange = e => {
    this.setState({
      isAdditionalMonths: !this.state.isAdditionalMonths
    });
  };
  onThirdPartyIntegrationsChange = e => {
    this.setState({
      isThirdPartyIntegrations: !this.state.isThirdPartyIntegrations
    });
  };

  onAddressChange = event => {
    const { value } = event.target;
    this.setState({ address: value, errorAddress: false });
  };
  onStateChange = event => {
    const { value } = event.target;
    this.setState({ state: value, errorState: false });
  };
  onCityChange = event => {
    const { value } = event.target;
    this.setState({ city: value, errorCity: false });
  };
  onCountryChange = event => {
    const { value } = event.target;
    this.setState({ country: value, errorCountry: false });
  };

  onPanChange = event => {
    const { value } = event.target;
    this.setState({ pan: value, errorPan: false });
  };
  onGstnChange = event => {
    const { value } = event.target;
    this.setState({ gstn: value, errorGstn: false });
  };
  onContactNameChange = event => {
    const { value } = event.target;
    this.setState({ contactName: value, errorContactName: false });
  };
  onCustomerEmailIdChange = event => {
    const { value } = event.target;
    this.setState({ customerEmailId: value, errorCustomerEmailId: false });
  };
  onSalesPersonPrimaryEmailChange = event => {
    event.preventDefault();
    event.stopPropagation();
    const { value } = event.target;
    if (value === this.state.salesPersonSecondaryEmail) {
      return this.setState({ errorSalesPersonalPrimaryEmail: true });
    }
    this.setState({
      salesPersonPrimaryEmail: value,
      errorSalesPersonalPrimaryEmail: false,
      errorSalesPersonalSecondaryEmail: false
    });
  };
  onSalesPersonSecondaryEmailChange = event => {
    event.preventDefault();
    event.stopPropagation();
    const { value } = event.target;

    if (this.state.salesPersonPrimaryEmail === value) {
      return this.setState({ errorSalesPersonalSecondaryEmail: true });
    }
    this.setState({
      salesPersonSecondaryEmail: value,
      errorSalesPersonalPrimaryEmail: false,
      errorSalesPersonalSecondaryEmail: false
    });
  };
  changeCompleteActivationTime = (date, time) => {
    if (date && time) {
      const completeActivationTime = moment(
        `${moment(date).format('YYYY-MM-DD')}_${time}`,
        'YYYY-MM-DD_HH:mm'
      )
        .toDate()
        .toISOString();
      this.setState({ completeActivationTime: completeActivationTime });
    }
  };
  onDateChange = event => {
    const { value } = event.target;
    this.setState({ validTill: value });
    const minDate = moment()
      .startOf('day')
      .valueOf();
    const selectedDate = moment(value)
      .startOf('day')
      .valueOf();
    if (minDate > selectedDate) {
      this.setState({ errorValidTill: true });
      return;
    }
    this.calcExpiryTime(value, this.state.validTime);
    this.setState({ errorValidTill: false, validTill: value });
  };
  onTimeChange = e => {
    const { value } = e.target;
    this.setState({ validTime: value, errorValidTime: false });
    this.calcExpiryTime(this.state.validTill, value);
  };
  calcExpiryTime = (date, time) => {
    if (date && time) {
      const expiryTime = moment(`${date}_${time}`, 'YYYY-MM-DD_HH:mm')
        .toDate()
        .toISOString();
      this.setState({ expiryTime: expiryTime });
    }
  };
  onKeyPress = e => {
    //to remove +,-,e when type = "number"
    if ((e.which !== 8 && e.which !== 0 && e.which < 48) || e.which > 57) {
      e.preventDefault();
    }
  };
  onDurationChange = e => {
    e.preventDefault();
    e.stopPropagation();
    const {
      target: { value }
    } = e;
    this.setState({
      duration: value,
      errorDuration: false
    });
  };
  offerMessage = e => {
    const {
      target: { value }
    } = e;
    this.setState({ offerMessage: value });
  };
  planAmountChange = e => {
    const {
      target: { value }
    } = e;
    this.setState({
      originalAmount: value,
      errorPlanAmount: false,
      disableDiscountField: false
    });
    if (!value) {
      this.setState({
        finalAmount: '',
        finalDiscountPercentage: '',
        discountAmount: '',
        discountPercent: '',
        disableDiscountField: true
      });
      return;
    }
    this.calcFinalDiscountPercentage(
      this.state.discountPercent,
      this.state.discountAmount,
      value
    );
    this.calcFinalAmount(
      this.state.discountPercent,
      this.state.discountAmount,
      value
    );
  };
  onChangeType = e => {
    e.preventDefault();
    e.stopPropagation();
    const {
      target: { value }
    } = e;
    this.setState({ planType: value });
  };

  onDiscountTypeChange = e => {
    e.preventDefault();
    e.stopPropagation();
    const {
      target: { value }
    } = e;
    this.setState({
      discountType: value,
      finalDiscountPercentage: '',
      finalAmount: '',
      discountPercent: '',
      discountAmount: '',
      errorDiscountAmount: false,
      errorDiscountPercent: false
    });
  };
  calcFinalDiscountPercentage = (
    discountPercent,
    discountAmount,
    originalPlanAmount
  ) => {
    if (discountPercent || discountAmount) {
      if (discountPercent && parseInt(originalPlanAmount)) {
        this.setState({ finalDiscountPercentage: discountPercent });
      } else if (parseInt(originalPlanAmount)) {
        discountAmount = Number(discountAmount);
        originalPlanAmount = Number(originalPlanAmount);
        discountPercent = Math.round(
          (discountAmount / originalPlanAmount) * 100
        );
        if (isNaN(discountPercent)) {
          this.setState({ finalDiscountPercentage: '' });
          return;
        }
        this.setState({ finalDiscountPercentage: discountPercent });
      }
    } else {
      this.setState({ finalDiscountPercentage: '' });
    }
  };
  calcFinalAmount = (discountPercent, discountAmount, originalPlanAmount) => {
    if (discountPercent || discountAmount) {
      if (discountAmount) {
        let amount = originalPlanAmount - discountAmount;
        this.setState({ finalAmount: amount });
      } else {
        discountPercent = Number(discountPercent);
        originalPlanAmount = Number(originalPlanAmount);
        discountAmount = Math.round(
          (discountPercent / 100) * originalPlanAmount
        );
        let amount = originalPlanAmount - discountAmount;
        if (isNaN(amount)) {
          this.setState({ finalAmount: '' });
          return;
        }
        this.setState({ finalAmount: amount });
      }
    } else {
      this.setState({ finalAmount: '' });
    }
  };

  onDiscountPercentChange = e => {
    const {
      target: { value }
    } = e;
    this.calcFinalDiscountPercentage(value, '', this.state.originalAmount);
    this.calcFinalAmount(value, '', this.state.originalAmount);
    this.setState({ discountPercent: value, errorDiscountPercent: false });
  };
  onDiscountAmountChange = e => {
    const {
      target: { value }
    } = e;
    this.calcFinalDiscountPercentage('', value, this.state.originalAmount);
    this.calcFinalAmount('', value, this.state.originalAmount);
    this.setState({ discountAmount: value, errorDiscountAmount: false });
  };
  onRefundDaysChange = e => {
    const {
      target: { value }
    } = e;

    this.setState({ refundDays: value, errorRefundDays: false });
  };
  validateForm = () => {
    let errorFlag = false;
    if (!this.state.companyId || this.state.errorCompanyID) {
      errorFlag = true;
      this.setState({ errorCompanyID: true });
    }
    if (
      !this.state.originalAmount ||
      Number(this.state.originalAmount) > 2000000 ||
      Number(this.state.originalAmount) < 1
    ) {
      errorFlag = true;
      this.setState({
        errorPlanAmount: true,
        originalAmount: '',
        finalDiscountPercentage: '',
        finalAmount: ''
      });
    }
    if (
      (!this.state.discountPercent &&
        this.state.discountType === 'Discount %') ||
      parseInt(this.state.discountPercent) < 1 ||
      parseInt(this.state.discountPercent) > 100
    ) {
      errorFlag = true;
      this.setState({
        errorDiscountPercent: true,
        discountPercent: '',
        finalDiscountPercentage: '',
        finalAmount: ''
      });
    }
    if (
      (!this.state.discountAmount &&
        this.state.discountType === 'Discount Amount') ||
      Number(this.state.discountAmount) < 0 ||
      Number(this.state.discountAmount) > Number(this.state.originalAmount)
    ) {
      errorFlag = true;
      this.setState({
        errorDiscountAmount: true,
        discountAmount: '',
        finalDiscountPercentage: '',
        finalAmount: ''
      });
    }
    if (
      this.state.refundDays &&
      (this.state.refundDays < 1 || this.state.refundDays > 14)
    ) {
      errorFlag = true;
      this.setState({ errorRefundDays: true });
    }
    if (this.state.salesPersonPrimaryEmail === 'Select Primary Email') {
      errorFlag = true;
      this.setState({ errorSalesPersonalPrimaryEmail: true });
    }
    if (!this.state.prorationNeeded) {
      errorFlag = true;
    }

    return errorFlag;
  };

  onGetEstimate = async () => {
    this.setState({
      errorGetEstimate: false
    });
    let errorFlag = this.validateForm();
    if (errorFlag) {
      return;
    }

    const sendGstnOrPan = () => {
      if (this.state.pan) {
        return { pan: this.state.pan };
      }
      if (this.state.gstn) {
        return { gst: this.state.gstn };
      }
    };

    const formData = {
      companyId: this.state.companyId,
      expiryTime: this.state.expiryTime,
      planExpiryTime: this.state.planExpiryTime,
      offerMessage: this.state.offerMessage,
      planType: this.state.planType,
      originalAmount: +this.state.originalAmount,
      duration: +this.state.duration,
      streetAddress: this.state.address,
      city: this.state.city,
      state: this.state.state,
      country: this.state.country,
      ...sendGstnOrPan(),
      contactPersonName: this.state.contactName,
      customerEmailId: this.state.customerEmailId,
      salesType: this.state.salesType,
      prorationNeeded: this.state.prorationNeeded,
      salesRepPrimaryEmail: this.state.salesPersonPrimaryEmail,
      salesRepSecondaryEmail:
        this.state.salesPersonSecondaryEmail === 'Select Secondary Email'
          ? ''
          : this.state.salesPersonSecondaryEmail,
      refundDays: this.state.refundDays ? +this.state.refundDays : null,
      discountType:
        this.state.discountType === 'Discount %' ? 'PERCENT' : 'ABSOLUTE',
      discountAmount:
        this.state.discountType === 'Discount %'
          ? +this.state.discountPercent
          : +this.state.discountAmount,
      additionalModules: {
        iOSNativeApp: this.state.isIOSNativeApp,
        androidNativeApp: this.state.isAndroidNativeApp,
        resellerChannels: this.state.isResellerChannels,
        resellerApp: this.state.isResellerApp,
        privacyModule: this.state.isPrivacyModule,
        whitelabel: this.state.isWhitelabel,
        amazonVoucherOf2k: this.state.isAmazonVoucherOf2k,
        additionalMonths: this.state.isAdditionalMonths,
        thirdPartyIntegrations: this.state.isThirdPartyIntegrations
      }
    };
    try {
      const { estimate } = await api.getEstimate(formData);
      this.setState({
        amountDue: estimate.invoiceAmountDue,
        errorGetEstimate: false
      });
    } catch (error) {
      console.log(error.response.statusText);
      this.setState({
        errorGetEstimate: true,
        errorMessage: error.response.data.message
      });
    }
  };

  onGenerateLink = async () => {
    this.setState({
      errorGeneratedLink: false
    });
    let errorFlag = this.validateForm();
    if (errorFlag) {
      return;
    }
    const sendGstnOrPan = () => {
      if (this.state.pan) {
        return { pan: this.state.pan };
      }
      if (this.state.gstn) {
        return { gst: this.state.gstn };
      }
    };

    const formData = {
      companyId: this.state.companyId,
      expiryTime: this.state.planExpiryTime,
      planExpiryTime: this.state.planExpiryTime,
      offerMessage: this.state.offerMessage,
      planType: this.state.planType,
      originalAmount: +this.state.originalAmount,
      duration: +this.state.duration,
      streetAddress: this.state.address,
      city: this.state.city,
      state: this.state.state,
      country: this.state.country,
      ...sendGstnOrPan(),
      contactPersonName: this.state.contactName,
      customerEmailId: this.state.customerEmailId,
      salesType: this.state.salesType,
      prorationNeeded: this.state.prorationNeeded,
      salesRepPrimaryEmail: this.state.salesPersonPrimaryEmail,
      salesRepSecondaryEmail:
        this.state.salesPersonSecondaryEmail === 'Select Secondary Email'
          ? ''
          : this.state.salesPersonSecondaryEmail,
      refundDays: this.state.refundDays ? +this.state.refundDays : null,
      discountType:
        this.state.discountType === 'Discount %' ? 'PERCENT' : 'ABSOLUTE',
      discountAmount:
        this.state.discountType === 'Discount %'
          ? +this.state.discountPercent
          : +this.state.discountAmount,
      additionalModules: {
        iOSNativeApp: this.state.isIOSNativeApp,
        androidNativeApp: this.state.isAndroidNativeApp,
        resellerChannels: this.state.isResellerChannels,
        resellerApp: this.state.isResellerApp,
        privacyModule: this.state.isPrivacyModule,
        whitelabel: this.state.isWhitelabel,
        amazonVoucherOf2k: this.state.isAmazonVoucherOf2k,
        additionalMonths: this.state.isAdditionalMonths,
        thirdPartyIntegrations: this.state.isThirdPartyIntegrations
      }
    };
    try {
      const { salesLink } = await api.generateUpgradeLink(formData);
      this.setState({
        salesLink: salesLink,
        showLinkGenerated: !this.state.showLinkGenerated,
        errorGeneratedLink: false
      });
      this.cleanState();
    } catch (error) {
      console.log(error.response.statusText);
      this.setState({
        errorGeneratedLink: true,
        errorMessage: error.response.data.message
      });
    }
  };
  cleanState = () => {
    this.setState({
      companyId: '',
      companyName: '',
      userPhone: '',
      userEmail: '',
      validTill: '',
      validTime: '',
      expiryTime: '',
      address: '',
      city: '',
      state: '',
      country: '',
      pan: '',
      gstn: '',
      contactName: '',
      customerEmailId: '',
      salesType: '',
      prorationNeeded: false,
      salesRepEmails: [],
      salesPersonPrimaryEmail: 'Select Primary Email',
      salesPersonSecondaryEmail: 'Select Secondary Email',
      errorMessage: '',
      planType: 'GROWTH',
      originalAmount: '',
      duration: '',
      offerMessage: '',
      discountType: 'Discount %',
      discountPercent: '',
      discountAmount: '',
      finalDiscountPercentage: '',
      finalAmount: '',
      refundDays: '',
      planExpiryTime: '',
      isIOSNativeApp: false,
      isAndroidNativeApp: false,
      isResellerChannels: false,
      isResellerApp: false,
      isPrivacyModule: false,
      isWhitelabel: false,
      isAmazonVoucherOf2k: false,
      isAdditionalMonths: false,
      isThirdPartyIntegrations: false,
      errorCompanyID: false,
      errorDuration: false,
      errorAddress: false,
      errorCity: false,
      errorState: false,
      errorCountry: false,
      errorPan: false,
      errorGstn: false,
      errorContactName: false,
      errorSalesPersonalPrimaryEmail: false,
      errorSalesPersonalSecondaryEmail: false,
      errorCustomerEmailId: false,
      errorValidTill: false,
      errorValidTime: false,
      errorPlanAmount: false,
      errorRefundDays: false,
      errorDiscountPercent: false,
      errorDiscountAmount: false,
      errorActivationDate: false,
      errorActivationTime: false,
      disableTextField: true,
      disableDiscountField: true,
      disablePlanTypeActivationTime: false
    });
  };
  onToggle = () => {
    this.setState({
      showLinkGenerated: !this.state.showLinkGenerated
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        {this.state.showLinkGenerated ? (
          <LinkGenerated
            onToggle={this.onToggle}
            salesLink={this.state.salesLink}
            mode="payment"
          />
        ) : (
          <Styled.GenerateUpgradePaymentLinkContainer>
            <Styled.Title>Payment link generator</Styled.Title>
            <FormControl>
              <Styled.LabelAndTextField>
                <Styled.Label>Company Id</Styled.Label>
                <Styled.InputField>
                  <TextField
                    id="CompanyID"
                    type="text"
                    inputMode={'numeric'}
                    autoComplete="off"
                    className={classes.textField}
                    onBlur={
                      this.state.prorationNeeded ? this.getCompanyDetails : null
                    }
                    onChange={this.companyIdChange}
                    value={this.state.companyId}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                  {this.state.errorCompanyID && (
                    <Styled.Error>Invalid CompanyId</Styled.Error>
                  )}
                  {!this.state.prorationNeeded && (
                    <Styled.Error>
                      Use &ldquo;Create payment link&rdquo; option for this
                      company
                    </Styled.Error>
                  )}
                </Styled.InputField>
                {this.state.loading && (
                  <Styled.LoaderContainer>
                    <CircularProgress size={20} thickness={5} color="primary" />
                  </Styled.LoaderContainer>
                )}
              </Styled.LabelAndTextField>
              <Styled.VerifyDetailsContainer>
                Please verify details:
                <Styled.DetailContainer>
                  <Styled.DetailTitle>Company Name</Styled.DetailTitle>
                  <Styled.Label>{this.state.companyName}</Styled.Label>
                </Styled.DetailContainer>
                <Styled.DetailContainer>
                  <Styled.DetailTitle>Phone</Styled.DetailTitle>
                  <Styled.Label>{this.state.userPhone}</Styled.Label>
                </Styled.DetailContainer>
                <Styled.DetailContainer>
                  <Styled.DetailTitle>Email</Styled.DetailTitle>
                  <Styled.Label>{this.state.userEmail}</Styled.Label>
                </Styled.DetailContainer>
                <Styled.DetailContainer>
                  <Styled.DetailTitle>Sales Type</Styled.DetailTitle>
                  {this.state.userEmail && (
                    <Styled.Label>{this.state.salesType}</Styled.Label>
                  )}
                </Styled.DetailContainer>
              </Styled.VerifyDetailsContainer>

              <Styled.LabelAndTextField>
                <Styled.Label>PAN</Styled.Label>
                <FormControl>
                  <TextField
                    disabled={this.state.disableTextField || !!this.state.gstn}
                    id="pan"
                    autoComplete="off"
                    type="text"
                    className={classes.textField}
                    style={{
                      backgroundColor: this.state.gstn ? 'lightgray' : 'white'
                    }}
                    onChange={this.onPanChange}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    value={this.state.pan}
                  />
                  {!!this.state.gstn && (
                    <Styled.Error>
                      Disabled as only GSTN or PAN can be used at once{' '}
                    </Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>

              <Styled.LabelAndTextField>
                <Styled.Label>GSTN</Styled.Label>
                <FormControl>
                  <TextField
                    disabled={this.state.disableTextField || !!this.state.pan}
                    id="gstn"
                    autoComplete="off"
                    type="text"
                    className={classes.textField}
                    style={{
                      backgroundColor: this.state.pan ? 'lightgray' : 'white'
                    }}
                    onChange={this.onGstnChange}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    value={this.state.gstn}
                  />
                  {!!this.state.pan && (
                    <Styled.Error>
                      Disabled as only GSTN or PAN can be used at once{' '}
                    </Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>

              <Styled.LabelAndTextField>
                <Styled.Label>
                  Email of Sales Person <br /> (Primary)
                </Styled.Label>
                <FormControl>
                  <Select
                    disabled={this.state.disableTextField}
                    className={classes.textField}
                    value={this.state.salesPersonPrimaryEmail}
                    onChange={this.onSalesPersonPrimaryEmailChange}
                  >
                    <MenuItem value={'Select Primary Email'}>
                      Select Primary Email
                    </MenuItem>
                    {this.state.salesRepEmails.map(email => {
                      return (
                        <MenuItem key={email} value={email}>
                          {email}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {this.state.errorSalesPersonalPrimaryEmail && (
                    <Styled.Error>
                      Primary email can not be empty or same as secondary email
                    </Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>
                  Email of Sales Person <br /> (Secondary)
                </Styled.Label>
                <FormControl>
                  <Select
                    disabled={this.state.disableTextField}
                    className={classes.textField}
                    value={this.state.salesPersonSecondaryEmail}
                    onChange={this.onSalesPersonSecondaryEmailChange}
                  >
                    <MenuItem value={'Select Secondary Email'}>
                      Select Secondary Email
                    </MenuItem>
                    {this.state.salesRepEmails.map(email => {
                      return (
                        <MenuItem key={email} value={email}>
                          {email}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {this.state.errorSalesPersonalSecondaryEmail && (
                    <Styled.Error>
                      Secondary email can not be same as primary email
                    </Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Plan Type</Styled.Label>
                <FormControl>
                  <Select
                    disabled={
                      this.state.disableTextField ||
                      this.state.disablePlanTypeActivationTime
                    }
                    className={classes.textField}
                    value={this.state.planType}
                    onChange={this.onChangeType}
                  >
                    <MenuItem value="GROWTH">GROWTH</MenuItem>
                    <MenuItem value="PLATINUM">PLATINUM</MenuItem>
                    <MenuItem value="PREMIUM">PREMIUM</MenuItem>
                    <MenuItem value="UNLIMITED">UNLIMITED</MenuItem>
                  </Select>
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Duration (months)</Styled.Label>
                <Styled.InputField>
                  <TextField
                    disabled={this.state.disableTextField}
                    id="Duration"
                    type="number"
                    autoComplete="off"
                    className={classes.textField}
                    value={this.state.duration}
                    onKeyPress={this.onKeyPress}
                    onChange={this.onDurationChange}
                    classes={{ root: classes.input }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                  {this.state.errorDuration && (
                    <Styled.Error>Invalid Duration</Styled.Error>
                  )}
                </Styled.InputField>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>
                  <Styled.OfferMessageTitle>
                    Offer Message
                  </Styled.OfferMessageTitle>
                  <Styled.OfferMessageDescription>
                    Example : Special CEO Approval
                  </Styled.OfferMessageDescription>
                </Styled.Label>

                <Styled.InputField>
                  <TextField
                    disabled={this.state.disableTextField}
                    type="text"
                    autoComplete="off"
                    className={classes.textField}
                    value={this.state.offerMessage}
                    onChange={this.offerMessage}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                </Styled.InputField>
              </Styled.LabelAndTextField>

              <Styled.VerifyDetailsContainer>
                <Styled.Label>Additional Modules</Styled.Label>
                <Styled.AdditionalModulesContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      iOS Native App
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isIOSNativeApp}
                        onChange={this.onIOSNativeAppChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      Android Native App
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isAndroidNativeApp}
                        onChange={this.onAndroidNativeAppChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      Reseller Channels
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isResellerChannels}
                        onChange={this.onResellerChannelsChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      Reseller App
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isResellerApp}
                        onChange={this.onResellerAppChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      Privacy Module
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isPrivacyModule}
                        onChange={this.onPrivacyModuleChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      Whitelabel
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isWhitelabel}
                        onChange={this.onWhitelabelChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      Amazon Voucher of 2k
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isAmazonVoucherOf2k}
                        onChange={this.onAmazonVoucherOf2kChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      Additional Months
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isAdditionalMonths}
                        onChange={this.onAdditionalMonthsChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      3rd Party Integrations
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isThirdPartyIntegrations}
                        onChange={this.onThirdPartyIntegrationsChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                </Styled.AdditionalModulesContainer>
              </Styled.VerifyDetailsContainer>

              <Styled.LabelAndTextField>
                <Styled.Label>Plan Amount</Styled.Label>
                <Styled.InputField>
                  <TextField
                    disabled={this.state.disableTextField}
                    id="planAmount"
                    type="number"
                    autoComplete="off"
                    className={classes.textField}
                    onKeyPress={this.onKeyPress}
                    value={this.state.originalAmount}
                    onChange={this.planAmountChange}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                  {this.state.errorPlanAmount && (
                    <Styled.Error>
                      Plan amount must be between 1 and 2,00,000
                    </Styled.Error>
                  )}
                </Styled.InputField>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Discount Type</Styled.Label>
                <FormControl>
                  <Select
                    disabled={this.state.disableTextField}
                    value={this.state.discountType}
                    onChange={this.onDiscountTypeChange}
                    className={classes.textField}
                  >
                    <MenuItem value="Discount %">Discount %</MenuItem>
                    <MenuItem value="Discount Amount">Discount Amount</MenuItem>
                  </Select>
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>{this.state.discountType}</Styled.Label>
                {this.state.discountType === 'Discount %' ? (
                  <Styled.InputField>
                    <TextField
                      disabled={this.state.disableDiscountField}
                      id="percentage"
                      type="number"
                      autoComplete="off"
                      onKeyPress={this.onKeyPress}
                      className={classes.textField}
                      value={this.state.discountPercent}
                      onChange={this.onDiscountPercentChange}
                      InputProps={{
                        disableUnderline: true,
                        classes: { input: classes.input }
                      }}
                      margin="normal"
                    />
                    {this.state.errorDiscountPercent && (
                      <Styled.Error>
                        Percentage must be between 1 and 100
                      </Styled.Error>
                    )}
                  </Styled.InputField>
                ) : (
                  <Styled.InputField>
                    <TextField
                      disabled={this.state.disableDiscountField}
                      id="amount"
                      type="number"
                      autoComplete="off"
                      value={this.state.discountAmount}
                      onChange={this.onDiscountAmountChange}
                      margin="normal"
                      className={classes.textField}
                      onKeyPress={this.onKeyPress}
                      InputProps={{
                        disableUnderline: true,
                        classes: { input: classes.input }
                      }}
                    />
                    {this.state.errorDiscountAmount && (
                      <Styled.Error>
                        {`Discount Amount must be between 0 and ${
                          this.state.originalAmount
                            ? this.state.originalAmount
                            : 'Plan Amount'
                        }`}
                      </Styled.Error>
                    )}
                  </Styled.InputField>
                )}
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Refund days</Styled.Label>
                <Styled.InputField>
                  <TextField
                    disabled={this.state.disableTextField}
                    id="Refund days"
                    type="number"
                    autoComplete="off"
                    className={classes.textField}
                    value={this.state.refundDays}
                    onKeyPress={this.onKeyPress}
                    onChange={this.onRefundDaysChange}
                    classes={{ root: classes.input }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                  {this.state.errorRefundDays && (
                    <Styled.Error>
                      Refund days must be between 1 and 14
                    </Styled.Error>
                  )}
                </Styled.InputField>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Final Amount</Styled.Label>
                <Styled.FinalPriceContainer>
                  <Styled.FinalAmount>
                    <Styled.FinalPrice>
                      {this.state.finalAmount || this.state.finalAmount === 0
                        ? `Rs.${this.state.finalAmount} `
                        : 'Final Amount'}
                    </Styled.FinalPrice>
                    <Styled.OriginalPrice>
                      {this.state.originalAmount
                        ? `Rs. ${this.state.originalAmount}`
                        : 'Original Amount'}
                    </Styled.OriginalPrice>
                  </Styled.FinalAmount>
                  <Styled.FinalPricePercentage>
                    {this.state.finalDiscountPercentage}% Discount
                  </Styled.FinalPricePercentage>
                </Styled.FinalPriceContainer>
              </Styled.LabelAndTextField>

              <Styled.LabelAndTextField>
                <Styled.InputField>
                  <Button
                    tabIndex="-1"
                    type="submit"
                    classes={{ root: classes.estimateButton }}
                    onClick={this.onGetEstimate}
                  >
                    Get estimate
                  </Button>
                  {this.state.errorGetEstimate && (
                    <Styled.Error>
                      {this.state.errorMessage
                        ? this.state.errorMessage
                        : 'Something went wrong'}
                    </Styled.Error>
                  )}
                </Styled.InputField>
                <Styled.FinalPriceContainer>
                  <Styled.FinalAmount>
                    <Styled.FinalPrice>
                      {this.state.amountDue
                        ? `Rs. ${this.state.amountDue} to be paid more`
                        : ''}
                    </Styled.FinalPrice>
                  </Styled.FinalAmount>
                </Styled.FinalPriceContainer>
              </Styled.LabelAndTextField>

              <Styled.LabelAndTextField>
                <Styled.InputField>
                  <Button
                    tabIndex="-1"
                    type="submit"
                    classes={{ root: classes.button }}
                    onClick={this.onGenerateLink}
                  >
                    Generate Payment Link
                  </Button>
                  {this.state.errorGeneratedLink && (
                    <Styled.Error>
                      {this.state.errorMessage
                        ? this.state.errorMessage
                        : 'Something went wrong'}
                    </Styled.Error>
                  )}
                </Styled.InputField>
              </Styled.LabelAndTextField>
            </FormControl>
          </Styled.GenerateUpgradePaymentLinkContainer>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(GenerateUpgradePaymentLink);



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/GenerateUpgradePaymentLink/index.js